<template>
  <div class="select-bg">
    <div class="select-container">
      <div class="select-title">
        <div class="select-btn cancel-btn" @click="$emit('cancel')">取消</div>
        <div class="select-btn confirm-btn" @click="$emit('confirm', selected)">确定</div>
      </div>
      <div class="select-content">
        <div v-for="option in options" :key="option.id" class="select-option" :data-active="option.id === selected" @click="selected = option.id">
          <span>{{ option.name }}</span>
          <i v-if="option.id === selected" class="el-icon-check" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      selected: 0
    };
  },
  mounted() {
    this.selected = this.value;
  },
};
</script>

<style lang="less" scoped>
.select-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);

  .select-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: fit-content;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    border-radius: 1.25rem 1.25rem 0 0;
    background-color: #FFFFFF;

    .select-title {
      width: 100%;
      height: 3rem;
      padding: 1rem 0.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1rem;

      .select-btn {
        width: 3rem;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        &.cancel-btn {
          color: #333333;
        }
        &.confirm-btn {
          color: #2173EA;
        }
      }
    }

    .select-content {
      width: 100%;
      height: 15rem;
      padding: 0 1rem;
      overflow: auto;
      scrollbar-width: none;

      .select-option {
        margin-bottom: 0.5rem;
        width: 100%;
        height: 3rem;
        padding: 0 0.5rem;
        border-radius: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        font-size: 1rem;

        &[data-active="true"] {
          color: #2173EA;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
